const Input = ({value = "", name, type="text", onChange, placeholder, startIcon, inputProps, borderless}) =>  
<div className="mt-2 flex rounded-md shadow-sm">
<div className="relative flex flex-grow items-stretch focus-within:z-10">
{startIcon && <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
  {startIcon({className:'h-4 w-4 text-gray-400'})}
</div>}
<input
    value={value}
    type={type}
    name={name}
    id={name}
    placeholder={placeholder}
    onChange={e => onChange(e.currentTarget.value)}
    {...inputProps}
    className={`block w-full rounded-md border-0 py-2 ${startIcon && 'pl-10'} text-gray-900 ${borderless ? 'shadow-none focus:ring-0' : 'ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600'} placeholder:text-gray-400 sm:text-sm sm:leading-6 ${inputProps?.className}`}
/>
</div>
</div>

export default Input;